var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.841797,
    y: 0.476562,
    width: 30.1746,
    height: 31.046,
    rx: 5,
    fill: "#0698D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.016 16.1854C23.0234 15.8676 22.9437 15.5538 22.7855 15.278C22.6274 15.0023 22.3968 14.775 22.1188 14.6209L11.6539 8.70537C11.3451 8.53075 10.9909 8.45316 10.6374 8.4827C10.2839 8.51223 9.94748 8.64753 9.67195 8.87097C9.39642 9.0944 9.19455 9.39563 9.09263 9.73541C8.99071 10.0752 8.99346 10.4378 9.10053 10.776L10.6103 15.5452L17.1915 15.5173C17.2677 15.5168 17.3432 15.5314 17.4138 15.5602C17.4844 15.5889 17.5485 15.6313 17.6027 15.685C17.6569 15.7386 17.6999 15.8023 17.7294 15.8726C17.7589 15.9428 17.7742 16.0182 17.7745 16.0944C17.7749 16.1706 17.7601 16.2461 17.7312 16.3167C17.7023 16.3872 17.6598 16.4513 17.6061 16.5053C17.5524 16.5594 17.4886 16.6023 17.4183 16.6317C17.3479 16.661 17.2725 16.6762 17.1963 16.6764L10.5068 16.7048L8.94284 21.1697C8.83324 21.4787 8.81232 21.8121 8.88243 22.1323C8.95255 22.4525 9.1109 22.7467 9.33957 22.9815C9.37641 23.0195 9.41548 23.0565 9.45657 23.0916C9.72446 23.3246 10.0567 23.4709 10.4094 23.5112C10.7622 23.5515 11.1189 23.484 11.4324 23.3174L22.0717 17.7219C22.3542 17.5761 22.5914 17.3559 22.7579 17.0851C22.9243 16.8143 23.0135 16.5032 23.016 16.1854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.59d802e9893336b1d34cc80a784d0023.svg";
export { ForwardRef as ReactComponent };